module.exports = __webpack_public_path__ + "img/资源服务中心图片.10a301ed.png";